import { filterObjectValues } from 'helpers/filter'

import { LogisticFilial } from 'models/logistic-filial'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api, { CreateLogisticFilialTagType } from '../api'
import {
  CreateLogisticFilial,
  GetLogisticFilialsParams,
  GetLogisticFilialsResponse,
  LogisticFilialReportType,
  UpdateLogisticFilialStatus,
} from './types'

export const logisticFilialsApi = api.injectEndpoints({
  endpoints: build => ({
    getLogisticFilials: build.query<
      GetLogisticFilialsResponse,
      GetLogisticFilialsParams
    >({
      query: params => ({
        url: `/web/logistic_cart_filial/`,
        params: filterObjectValues(params),
        cache: 'no-store',
      }),
      providesTags: [CreateLogisticFilialTagType],
    }),
    getLogisticFilialsBranches: build.query<
      Array<{ id: number; name: string }>,
      void
    >({
      query: () => ({
        url: `/web/logistic_cart_filial/branch_list/`,
        // params: filterObjectValues(params),
        cache: 'no-store',
      }),
    }),
    getLogisticFilialById: build.query<LogisticFilial, LogisticFilial['id']>({
      query: id => ({
        url: `/web/logistic_cart_filial/${id}/`,
      }),
      providesTags: [CreateLogisticFilialTagType],
    }),
    createLogisticFilial: build.mutation<LogisticFilial, CreateLogisticFilial>({
      query: body => ({
        method: 'post',
        url: '/web/logistic_cart_filial/',
        body,
      }),
      invalidatesTags: [CreateLogisticFilialTagType],
    }),
    editLogisticFilial: build.mutation<
      LogisticFilial,
      { id: number; body: CreateLogisticFilial }
    >({
      query: ({ id, body }) => ({
        method: 'put',
        url: `/web/logistic_cart_filial/${id}/`,
        body,
      }),
      invalidatesTags: [CreateLogisticFilialTagType],
    }),
    logisticFilialStatistics: build.query<
      Array<IStatistic>,
      GetLogisticFilialsParams
    >({
      query: params => ({
        url: `/web/logistic_cart_filial/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60,
    }),
    updateLogisticFilialStatus: build.mutation<
      void,
      UpdateLogisticFilialStatus
    >({
      query: ({ id, body }) => ({
        method: 'put',
        url: `/web/logistic_cart_filial/${id}/change-status/`,
        body,
      }),
      invalidatesTags: [CreateLogisticFilialTagType],
    }),
    downloadLogisticFilialExcel: build.mutation<
      void,
      { params: GetLogisticFilialsParams; type?: LogisticFilialReportType }
    >({
      query: ({ params, type = LogisticFilialReportType.DEFAULT }) => ({
        url: `/web/logistic_cart_filial/${type}/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
